import { slugifyRegion } from '../utils/regionSlugs';
import { normalizeCityCode, resolveLocationCityCode } from './cityCode';

/**
 * 생활정보 SafePath 허브 스코프: 국가(ISO2) + 도시 슬러그만 사용 (동/구 단위 없음)
 * @param {{
 *   selectedRegions?: string[],
 *   activeRegionSlot?: number | null,
 *   currentCountry?: string,
 *   activeRegionView?: { cityCode?: string, countryCode?: string, label?: string } | null,
 * }} ctx
 * @returns {{ country: string, city: string, regionKey: string, displayLabel: string }}
 */
export function resolveLifeInfoLocation(ctx = {}) {
  const { selectedRegions, activeRegionSlot, currentCountry, activeRegionView } = ctx;
  const slot = activeRegionSlot === 1 ? 1 : 0;
  const label = (Array.isArray(selectedRegions) && selectedRegions[slot]) || selectedRegions?.[0] || '';
  const cityCode = normalizeCityCode(activeRegionView?.cityCode || inferCityCodeFromLabel(label));
  const country = String(activeRegionView?.countryCode || currentCountry || inferCountryFromLabel(label) || 'VN')
    .toUpperCase()
    .slice(0, 2)
    .toLowerCase();
  const city = citySlugFromCodeOrLabel(cityCode, label, country);
  const regionKey = `${country}:${city}`;
  const displayLabel = String(activeRegionView?.label || '').trim() || displayFromLabel(label, country, city);
  return { country, city, regionKey, displayLabel };
}

function inferCityCodeFromLabel(label) {
  return resolveLocationCityCode(label);
}

function inferCountryFromLabel(label) {
  const s = slugifyRegion(label);
  if (!s) return 'VN';
  if (s.includes('seoul') || s.includes('busan') || s.includes('korea') || /한국|서울|부산/.test(label)) return 'KR';
  return 'VN';
}

function citySlugFromCodeOrLabel(cityCode, label, country) {
  const slug = normalizeCityCode(cityCode) || normalizeCityCode(label);
  if (slug) return slug;
  const s = slugifyRegion(label);
  if (!s) {
    if (country === 'kr') return 'seoul';
    return 'unknown';
  }
  if (s.includes('danang')) return 'danang';
  if (s.includes('hoian') || s.includes('hoi')) return 'hoian';
  if (s.includes('hue') || s.includes('hu')) return 'hue';
  if (s.includes('hanoi')) return 'hanoi';
  if (s.includes('hochiminh') || s.includes('saigon')) return 'hochiminh';
  if (s.includes('seoul')) return 'seoul';
  if (s.includes('busan')) return 'busan';
  if (country === 'kr') return 'seoul';
  return s.slice(0, 32) || 'unknown';
}

function displayFromLabel(label, country, city) {
  if (label && String(label).trim()) return String(label).trim();
  if (country === 'kr') {
    if (city === 'busan') return '부산';
    return '서울';
  }
  if (city === 'hue') return 'Hue';
  if (city === 'hoian') return 'Hội An';
  if (city === 'hanoi') return 'Hà Nội';
  if (city === 'hochiminh') return 'TP.HCM';
  return 'Vietnam';
}
